// dependencies
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import ReactDOM from "react-dom";

// components
import Chip from "../../components/Chip";

import { useFeatureFlagQuery } from "../../hooks/useFeatureFlag";

const BranchName = (props) => {
	const { errorBoundary } = props;
	const { value: hideBranchName, query: hideBranchNameQuery } = useFeatureFlagQuery("ff-hide-branch-name", false);

	const ignoreDomains = [
		"talent.performyard.com",
		"sandbox.talent.performyard.com",
		"localhost:8888",
		"demo.talent.performyard.com",
	];

	const currentDomain = window.location.host;

	// only calculate whether to display branch name is domain name changes
	const displayBranchName = useMemo(() => {
		let result = true;
		for (let i = 0; i < ignoreDomains.length; i += 1) {
			if (ignoreDomains[i] === currentDomain) {
				result = false;
				break;
			}
		}
		return result;
	}, [currentDomain]);

	if (errorBoundary || hideBranchName || hideBranchNameQuery.isLoading) {
		return null;
	}

	const rootElement = document.getElementById("branch-name");
	const branchName = rootElement.getAttribute("data-branch") || "";

	const content = <div>{displayBranchName && branchName ? <Chip label={branchName} color="red" /> : null}</div>;

	return ReactDOM.createPortal(content, rootElement);
};

BranchName.propTypes = {
	errorBoundary: PropTypes.bool,
};

export default BranchName;
